import { Box, Flex, Heading, Text, useDisclosure } from "@chakra-ui/react";
import { WithAuth } from "@/hoc";
import { useEffect, useState } from "react";
import { BackButton, Tabs } from "@/components";
import DynamicTable from "@/components/DynamicTable";
import { SettingsWheelIcon } from "@/styles/icons";
import { formatCurrency, formatInvoiceStatusIcon, formatInvoiceStatusText } from "@/utils";
import { useCreditCard } from "@/hooks/useCreditCard";
import { parse, format } from "date-fns";
import { ptBR } from "date-fns/locale";
import ConfigCreditCard from "../configurar-cartao";
import { useNavigate } from "react-router-dom";
import { DrawerPaymentInvoice } from "../drawer-fatura-pagamento";
import { Button, PageHeading } from "barte-design-system";

const ManageCreditCardInvoicesPage = () => {
  const [activeTab, setActiveTab] = useState("PAST_INVOICES");
  const navigate = useNavigate();
  const {
    getInitialCreditCardInvoicesListData,
    creditCardsInvoices,
    initialDataIsLoading
  } = useCreditCard();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { isOpen: isOpenInvoiceToPay, onClose: onCloseInvoiceToPay, onOpen: onOpenInvoiceToPay } = useDisclosure();
  function formatDateToTable(date: string) {
    const formattedDate = parse(date, "yyyy-MM", new Date());
    const formatted = format(formattedDate, "MMMM yyyy", { locale: ptBR });
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  }
  const columns = [
    {
      key: "yearMonth",
      title: "Mês",
      dataIndex: "yearMonth",
      sorter: false,
      render: (yearMonth: string) => (
        <Flex align="center">
          <Text
            fontWeight={600}
          >
            {formatDateToTable(yearMonth)}
          </Text>
        </Flex>
      ),
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sorter: true,
      render: (status) => (
        <Flex align="center" gridGap="2">
          <Box
            border="1px solid #000"
            borderRadius="4px"
            p="1px"
          >
            {formatInvoiceStatusIcon(status)}
          </Box>
          <Text
            fontWeight={400}
            fontSize="12px"
          >
            {formatInvoiceStatusText(status)}
          </Text>
        </Flex>
      ),
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      sorter: false,
      emptyText: true,
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      sorter: false,
      emptyText: true,
    },
    {
      key: "totalAmount",
      title: "Valor total",
      dataIndex: "totalAmount",
      sorter: true,
      render: (totalAmount) => (
        <Flex align="center" gridGap="2">
          <Text
            fontWeight={400}
            fontSize="12px"
          >
            {formatCurrency({ value: totalAmount })}
          </Text>
        </Flex>
      ),
    },
  ];
  const isValidToNotPay = creditCardsInvoices?.every(item => item.status === "OPEN" || item.status === "PAID") || false;
  const TabContent = () => {
    return (
      <Flex
        flexDir="column"
        w="100%"
        position="relative"
      >
    
        <DynamicTable
          columns={columns}
          data={creditCardsInvoices}
          locale={{ emptyText: "Sem dados das faturas" }}
          loading={initialDataIsLoading}
          onRowClick={(record) => navigate(`/cartao/faturas/${record.yearMonth}`)}
          rowKey={(record) => record.yearMonth}
        />
      </Flex>
    )
  }


  useEffect(() => {
    getInitialCreditCardInvoicesListData();
  }, [])
  return (
    <>
      <DrawerPaymentInvoice
        isOpen={isOpenInvoiceToPay}
        onClose={onCloseInvoiceToPay}
      />
      <ConfigCreditCard
        isOpen={isOpen}
        onClose={onClose}
      />
      <Flex
        w="100%"
        justify="center"
        align="center"
        flexDir="column"
      >

        <PageHeading
          title="Faturas"
          onBack={() => navigate(-1)}
          secondaryActionLabel="Configurações"
          onSecondaryAction={onOpen}
          primaryActionLabel={isValidToNotPay ? "Pagar" :null}
          onPrimaryAction={onOpenInvoiceToPay}
        />
        <Flex
          flexDir="column"
          width="100%"
          gap="1rem"
          py="4"
          maxW="1280px"
        >

          <TabContent />
        </Flex>
      </Flex>
    </>
  );
};

export default WithAuth(ManageCreditCardInvoicesPage);
